import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  async getAllSMSMessages(_obj, params) {
    const res = await axios.get('api/sms/messages/', { params });
    return res.data;
  },
  async getContactSMSThread(_obj, contactId) {
    const res = await axios.get(`api/sms/messages/thread/${contactId}/`);
    return res.data;
  },
  async getSMSConversations() {
    const res = await axios.get('api/sms/messages/conversations/');
    return res.data;
  },
  async sendSMS(_obj, data) {
    return axios.post('api/sms/send/', data);
  },
  async sendBulkSMS(_obj, data) {
    return axios.post('api/sms/send-bulk/', data);
  },
};

export const sms = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
